<div class="notepad-container">
  <section class="header">
    <label for="enabledCategories"
      >{{ 'LOCATION.LABEL.ENABLED_CATEGORIES' | translate }}:</label
    >
    <p-multiSelect
      [options]="categories"
      [(ngModel)]="selectedCategories"
      name="enabledCategories"
      (onChange)="filterEntries()"
    />

    @if (canAddEntries) {
      <p-button
        label="{{ 'CRM.LABEL.BUTTONS.ADD_ENTRY' | translate }}"
        class="p-button-raised p-button-success right-align"
        (click)="showEntryForm()"
        [disabled]="!canAddEntries"
      />
    }
  </section>

  <p-divider />

  <section class="notepad-entries">
    @for (entry of this.filteredEntries; track entry.id) {
      <app-log-entry
        [entry]="entry"
        [canEdit]="canEditEntry(entry)"
        [canDelete]="canDeleteEntry(entry)"
        (deleteEvent)="deleteEntry(entry)"
        (editEvent)="onEntryEdit(entry)"
      />
    }
    @if (this.filteredEntries.length === 0) {
      <p>
        {{ 'LOCATION.MESSAGES.INFO.NO_NOTEPAD_ENTRIES' | translate }}
      </p>
    }
  </section>
</div>

<p-dialog
  [header]="entryFormHeader"
  [(visible)]="showEntryDialog"
  showEffect="fade"
  [modal]="true"
  [transitionOptions]="'0ms'"
  (onHide)="onEntryDialogHide()"
  [style]="{ width: '1000px' }"
>
  @if (!entryFormWorking) {
    <form [formGroup]="addEntryForm" class="form">
      <div id="add-entry-create-form">
        <div class="panel">
          <div class="form-body">
            <div>
              <span class="label"
                >{{ 'LOCATION.LABEL.BUTTONS.ARCHIVED' | translate }}:
              </span>
              <span class="radio-wrapper">
                <label>{{ 'COMMON.LABEL.BUTTONS.YES' | translate }}</label>
                <p-radiobutton
                  name="archived"
                  [value]="true"
                  formControlName="archived"
                  styleClass="radio"
                />
              </span>
              <span class="radio-wrapper">
                <label>{{ 'COMMON.LABEL.BUTTONS.NO' | translate }}</label>
                <p-radiobutton
                  name="archived"
                  [value]="false"
                  formControlName="archived"
                  styleClass="radio"
                />
              </span>
            </div>
            <div>
              <span class="label"
                >{{ 'ADMIN.LABEL.CATEGORY' | translate }}:
              </span>
              <span class="category-wrapper">
                <p-select
                  formControlName="category"
                  [options]="categories"
                  placeholder="{{
                    'LOCATION.LABEL.SELECT_CATEGORY' | translate
                  }}"
                />
              </span>
            </div>
            <span class="label"
              >{{ 'MONLOG.LABEL.PLEASE_INSERT_STATUS' | translate }}:</span
            >

            @if (showEntryDialog) {
              <app-note-editor
                formControlName="entryText"
                (textChange)="validateForm()"
              />
            }
          </div>

          <div class="label">
            {{ 'MONLOG.LABEL.ENTRY_LABEL' | translate }}
          </div>

          <div class="modal-buttons">
            <button
              pButton
              label="{{ 'COMMON.LABEL.BUTTONS.OK' | translate }}"
              icon="fa fa-fw fa-check"
              (click)="saveEntry()"
              [disabled]="!this.addEntryForm.valid"
            ></button>
            <button
              pButton
              label="{{ 'COMMON.LABEL.BUTTONS.CANCEL' | translate }}"
              icon="fa fa-fw fa-ban"
              (click)="onEntryDialogHide()"
            ></button>
          </div>
        </div>
      </div>
    </form>
  } @else {
    <app-progress-spinner [enabled]="entryFormWorking" />
  }
</p-dialog>
